import { useEffect, useState } from "react";

import { useModalForm } from "../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../layouts/MainPagetitle";
import ConnectorSearch from "./ConnectorSearch";

const Connectors = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const [rowcount, setRowcount] = useState(0);
  const [connectorId, setConnectorId] = useState(null);
  const columns = [
    {
      dataIndex: "full_name",
      title: "Connector Name",
      render: (text, record) => {
        return (
          <>
            <span
              className="table-primary-text text-decoration-underline cursor-pointer"
              onClick={(e) => view(record)}
            >
              {text}
            </span>
          </>
        );
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "bank_details",
      title: "Bank Name",
      render: (text, record) => {
        return (
          <>{record?.bank_details?.bank_account_holder_bank_name || "-"}</>
        );
      },
    },
    {
      dataIndex: "email_address",
      title: "Email ID",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        const verificationStatus = {
          isAadharVerified: record?.is_aadhar_verified,
          is_agreement_signed: record?.is_agreement_signed,
          isPanVerified: record?.is_pan_code_verified,
        };
        let status = Object.values(verificationStatus).includes(false)
          ? "Pending"
          : "Completed";
        return (
          <AppTag color={status === "Pending" ? "warning" : "success"}>
            {status || "-"}
          </AppTag>
        );
      },
    },
  ];

  const connectorLeadColumns = [
    {
      dataIndex: "created_by",
      title: "Connector Name",
      render: (text, record) => {
        return (
          <span className="table-primary-text">
            {record?.created_by?.full_name || "-"}
          </span>
        );
      },
    },
    {
      dataIndex: "borrower_first_name",
      title: "Customer First Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text || "-"}</span>;
      },
    },
    {
      dataIndex: "borrower_last_name",
      title: "Customer Last Name",
      render: (text, record) => {
        return <span className="table-primary-text">{text || "-"}</span>;
      },
    },
    {
      dataIndex: "borrower_mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "application_product_type",
      title: "Loan Type",
      render: (text) => {
        return <>{_enum.LOAN_TYPES_MAP[text]}</>;
      },
    },
    {
      dataIndex: "loan_applied_amount",
      title: "Loan Amt.",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "application",
      title: "Disb. Amt.",
      render: (text, record) => {
        return <>{record?.application?.loan_disbursed_amount?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "application",
      title: "Payment Status",
      render: (text, record) => {
        return <>{record?.payment_status || "-"}</>;
      },
      // render: (text, record) => {
      //   let status = record?.application?.application_status;
      //   return (
      //     <AppTag color={_enum.STATUS_COLOR_MAP[status?.toLowerCase()]}>
      //       {status?.toTitleCase() || "-"}
      //     </AppTag>
      //   );
      // },
    },
  ];

  // ----------------- UI helpers -----------------
  const [activeKey, setActiveKey] = useState(null);
  const filterTabData = [
    { key: "allconnectors", name: "All Connectors" },
    { key: "connectorleads", name: "Connectors Lead" },
  ];

  const handleSelect = (e, key) => {
    setActiveKey(key);
    props.navigate(`/app/connectors?activetab=${key}`);
  };
  // ----------------------------------------------------------------
  const modalConfigs = {
    connectorInfo: [
      {
        label: "Name (As per PAN)",
        name: "full_name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
        rules: _enum.ONLY_STRING_RULE,
        disableWhen: (data) => data.is_agreement_signed === true,
      },
      {
        label: "Mobile Number",
        name: "mobile_number",
        type: "text",
        placeholder: "Please Enter",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
        disableWhen: (data) => data.is_agreement_signed === true,
      },
      {
        label: "Email ID",
        name: "email_address",
        type: "email",
        placeholder: "Please Enter",
        rules: _enum.EMAIL_RULE,
        required: true,
        disableWhen: (data) => data.is_agreement_signed === true,
      },
      {
        label: "Account Holder Name",
        name: "bank_account_holder_name",
        type: "text",
        placeholder: "Please Enter",
      },
      {
        label: "Account No.",
        name: "bank_account_number",
        type: "text",
        required: true,
        placeholder: "Please Enter",
      },
      {
        label: "Re-enter account No.",
        name: "reEnterAccountNumber",
        type: "text",
        required: true,
        confirmOf: "bank_account_number",
        errorMessage: "Account numbers do not match",
      },
      {
        label: "Account type",
        name: "bank_account_type",
        type: "select",
        options: _enum.ACCOUNT_TYPE,
      },
      {
        label: "Bank name",
        name: "bank_account_holder_bank_name",
        type: "select",
        options: [],
        fetchKey: "bank_account_holder_bank_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetBanknames();
          if (data) return data;
          return [];
        },
        placeholder: "Please Select",
      },
      {
        label: "IFSC code",
        name: "bank_account_holder_bank_IFSC",
        type: "text",
      },
      {
        label: "Work Location",
        name: "work_location",
        type: "select",
        options: [],
        fetchKey: "location_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetMasterLocations();
          if (data) return data?.options("location_name");
          return [];
        },
        placeholder: "Please Select",
      },
      {
        label: "State",
        name: "state",
        type: "text",
        placeholder: "Auto populated",
        readOnly: true,
      },
      {
        label: "City",
        name: "city",
        type: "text",
        placeholder: "Auto populated",
        readOnly: true,
      },
    ],
  };

  const dependencies = {
    work_location: async (value) => {
      if (value) {
        const res = await props.apis.apiGetLocationByName({
          location_name: value,
        });
        if (res) {
          return {
            valueUpdates: {
              state: res?.state,
              city: res?.city,
            },
          };
        }
      }
      return {};
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const view = (record) => {
    props.navigate(
      `/app/connectorsview?connectorId=${
        record?.connector_id || record?.created_by?.connector_id
      }`
    );
  };

  const edit = async (record) => {
    const data = await props.apis.apiGetConnectorDetailsById({
      connector_id: record.connector_id,
    });
    setConnectorId(record.connector_id);
    openModal("connectorInfo", "edit", "Edit Connector", {
      ...data,
      ...data?.bank_details,
      reEnterAccountNumber: data?.bank_details?.bank_account_number,
    });
  };

  const deleteConnector = (record) => {
    swal2
      .fire({
        title: "Are you sure you want to delete this connector?",
        icon: "info",
        iconColor: "#234C9B",
        showCancelButton: true,
        confirmButtonColor: "#234C9B",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiUpdateConnectorDeletionDetailsById(
              {
                is_deleted: true,
              },
              {
                connector_id: record.connector_id,
              }
            )
            .then((res) => {
              swal2.fire({
                title: "Connector deleted successfully !!",
                icon: "success",
                iconColor: "#234C9B",
                timer: 4000,
              });
              getConnectors();
            });
        }
      });
  };

  const handleAppModalSubmit = async (data) => {
    let payload = {
      ...Object.except(data, ["reEnterAccountNumber", "state", "city"]),
    };
    if (modalState.mode === "edit" && modalState.type === "connectorInfo") {
      const res = await props.apis.apiUpdateConnectorDetailsById(payload, {
        connector_id: connectorId,
      });
      if (res) {
        swal2.fire({
          title: "Connector updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          timer: 4000,
        });
        closeModal();
        getConnectors();
      }
    }
  };

  // ----------------------------------------------------------------
  const downloadExcel = async () => {
    let payload = {};
    if (activeKey === "allconnectors") {
      props.apis.apiExportConnectors(payload).then(async (res) => {
        if (res) {
          let data = await res;
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", `Connectors_Details.xlsx`);
          link.click();
        }
      });
    }

    if (activeKey === "connectorleads") {
      props.apis.apiExportAllConnectorLeads(payload).then(async (res) => {
        if (res) {
          let data = await res;
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", `Connector_Leads_Details.xlsx`);
          link.click();
        }
      });
    }
  };

  const getConnectors = (params = {}, reset) => {
    // console.log({ params, reset });
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["limit", "page"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    // console.log({ payload });

    if (activeKey === "allconnectors") {
      props.apis.apiGetAllConnectors(payload).then(({ data, total }) => {
        setTableData(data);
        setIsFetching(false);
        setRowcount(total);
      });
    }

    if (activeKey === "connectorleads") {
      props.apis
        .apiGetConnectorLeadsForAdmin(payload)
        .then(({ data, total }) => {
          setTableData(data);
          setIsFetching(false);
          setRowcount(total);
        });
    }
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on digirep", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getConnectors(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getConnectors(data, reset);
    }
  };

  useEffect(() => {
    // Set activeKey only once on mount
    const paramsActiveTab = props.urlparams?.params?.activetab;
    setActiveKey(paramsActiveTab || "allconnectors");
  }, []);

  useEffect(() => {
    if (activeKey) {
      getConnectors();
    }
  }, [activeKey]);

  props.$setNode({
    props,
  });

  return (
    <>
      <MainPagetitle
        mainTitle="Connectors"
        pageTitle={"Connectors"}
        parentTitle={"Home"}
        pageIcon={imagepaths.LeadsIconActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="filter_tab_container px-4">
                  {filterTabData.map((btn) => (
                    <button
                      key={btn.key}
                      type="button"
                      id={btn.key}
                      className={Object.className({
                        active: activeKey === btn.key,
                      })}
                      onClick={(...args) => handleSelect(...args, btn.key)}
                    >
                      {btn.name}
                    </button>
                  ))}
                </div>

                <ConnectorSearch
                  inactive={props.inactive}
                  onSearch={(...arg) => onSearch(...arg)}
                  downloadExcel={(...args) => downloadExcel(...args)}
                />
                <AppTable
                  data={tableData}
                  columns={
                    activeKey === "connectorleads"
                      ? connectorLeadColumns
                      : columns
                  }
                  onChange={(...arg) => {
                    const page = arg[0];
                    setSearch((prev) => ({
                      ...prev,
                      page: page.current,
                      limit: page.pageSize,
                    }));
                    getConnectors({ page: page.current, limit: page.pageSize });
                  }}
                  total={rowcount}
                  reorder={true}
                  {...(activeKey === "connectorleads"
                    ? {
                        viewable: true,
                        editable: false,
                        deletable: false,
                      }
                    : {})}
                  viewAction={(e) => view(e)}
                  editAction={(e) => edit(e)}
                  deleteAction={(e) => deleteConnector(e)}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />
    </>
  );
};

export default constore(Connectors);
